import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { PostmethodService } from '../../app-config/postmethod.service';

@Injectable({
  providedIn: 'root'
})
export class EmailSettingsService {

  constructor(private ws: PostmethodService) { }

  getOutletDetails(queryParams: any) {
    return this.ws.wsGet(environment.baseUrl + "/masters/outlet/" + queryParams);
  }

  updateEmailDetails(data: any) {
     return this.ws.wsPost(data, environment.baseUrl + "/masters/outlet/updateOutletEmails");
  }
}
